export enum VIRTUAL_MODULE_REFERENCE_SECTION {
  WORKFLOWS = 'Workflows',
}

export enum VIRTUAL_MODULE_REFERENCE_CATEGORY {
  SECURITY_OPTION = 'Security Option',
  SOURCE = 'Source',
}

export enum VIRTUAL_MODULE_SECURITY_OPTION_REFERENCE_CATEGORY_FIELD {
  TYPE = 'Type',
}

export enum VIRTUAL_MODULE_SOURCE_REFERENCE_CATEGORY_FIELD {
  TYPE = 'Type',
}
export enum WORKFLOW_FEEDBACK {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}
export enum BUTTON_TYPES {
  ICON_TEXT_BUTTON = 'ICON_TEXT_BUTTON',
  ICON_BUTTON = 'ICON_BUTTON',
  TOGGLE_BUTTON = 'TOGGLE_BUTTON',
}

export enum WORKFLOW_STATUS {
  ACTIVE = 'ACTIVATED',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  DEACTIVATE = 'DEACTIVATED',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  NO_STATUS_CHANGE = 'NO_STATUS_CHANGE',
  PENDING_AUTHORIZATION = 'PENDING_AUTHORIZATION',
  REJECTED = 'REJECTED',
  RETURNED = 'RETURNED',
}

export enum AUTHORIZATION_STATUS {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}
export enum STAGE_ACTION {
  APPROVE = 'APPROVE',
  CANCEL = 'CANCEL',
  COMPLETE = 'COMPLETE',
  DELETE = 'DELETE',
  DOWNLOAD = 'DOWNLOAD',
  DRAFT = 'DRAFT',
  REJECT = 'REJECT',
  RESTORE = 'RESTORE',
  RETURN = 'RETURN',
  SUBMIT = 'SUBMIT',
}

export enum TRUE_ACTIONS {
  ACTIVATE = 'ACTIVATE:DEACTIVATE',
  ENABLE = 'ENABLE:DISABLE',
}

export enum STAGE_ROUTING_STATUS {
  APPROVED = 'Approved',
  CANCELLED = 'Cancelled',
  COMPLETED = 'Completed',
  DELETED = 'Deleted',
  DRAFT = 'Draft',
  IN_PROGRESS = 'In Progress',
  NO_STATUS_CHANGE = 'No Status Change',
  REJECTED = 'Rejected',
  REQUEST_SUBMITTED = 'Request Submitted',
  REQUEST_DRAFTED = 'Request Drafted',
  RETURNED = 'Returned',
  SUBMITTED = 'Submitted',
}

export enum STAGE_STATUS_ACTION_TYPES {
  DELETE = 'Delete',
  DOWNLOAD = 'Download',
  EDIT = 'Edit',
  EVALUATE = 'Evaluate',
  LINK_SEND = 'Link Send',
  NEXT_STAGE = 'Next Stage',
  RESTORE = 'Restore',
  VIEW = 'View',
}

export enum ICON_OPTIONS {
  CANCEL = 'cancel',
  DELETE = 'delete',
  DOWNLOAD = 'download',
  EDIT = 'edit',
  EVALUATE = 'assignment_turned_in',
  LINK = 'link',
  RESTORE = 'restore_from_trash',
  SHARE = 'share',
  VIEW = 'visibility',
}

export enum TOGGLE_OPTIONS {
  ACTIVE = 'ACTIVATE : DEACTIVATE',
  ENABLE = 'ENABLE :DISABLE',
}

export enum STAGE_STATUS {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export enum PAYOUTS_PERMISSION_ACTIONS {
  APPROVE = 'APPROVE',
  APPROVE_CANCELLATION = 'APPROVE_CANCELLATION',
  APPROVE_REPROCESSING = 'APPROVE_REPROCESSING',
  DELETE_BATCHES = 'DELETE:BATCHES',
  DELETE_COMMISSION_BREAKDOWN = 'DELETE:COMMISSION_BREAKDOWN',
  DELETE_DEDUCTIONS = 'DELETE:DEDUCTIONS',
  DELETE_EARNINGS = 'DELETE:EARNINGS',
  DELETE_ENTRIES = 'DELETE:ENTRIES',
  EDIT_BATCHES = 'EDIT:BATCHES',
  EDIT_COMMISSION_BREAKDOWN = 'EDIT:COMMISSION_BREAKDOWN',
  EDIT_DEDUCTIONS = 'EDIT:DEDUCTIONS',
  EDIT_EARNINGS = 'EDIT:EARNINGS',
  EDIT_ENTRIES = 'EDIT:ENTRIES',
  GENERATE_BANK_ORDER = 'GENERATE_BANK_ORDER',
  PROCESS_PAYMENT = 'PROCESS_PAYMENT',
  PRINT_PAYSLIP = 'PRINT_PAYSLIP',
  READ_BANK_ORDER = 'READ:BANK_ORDER',
  READ_BATCHES = 'READ:BATCHES',
  READ_COMMISSION_BREAKDOWN = 'READ:COMMISSION_BREAKDOWN',
  READ_DEDUCTIONS = 'READ:DEDUCTIONS',
  READ_EARNINGS = 'READ:EARNINGS',
  READ_ENTRIES = 'READ:DATA_ENTRIES',
  REJECT_CANCELLATION = 'REJECT_CANCELLATION',
  REQUEST_APPROVAL = 'REQUEST_APPROVAL',
  REQUEST_CANCELLATION = 'REQUEST_CANCELLATION',
  VIEW_BREAKDOWN = 'VIEW_BREAKDOWN',
  WRITE_BANK_ORDER = 'WRITE:BANK_ORDER',
  WRITE_BATCHES = 'WRITE:BATCHES',
  WRITE_COMMISSION_BREAKDOWN = 'WRITE:COMMISSION_BREAKDOWN',
  WRITE_DEDUCTIONS = 'WRITE:DEDUCTIONS',
  WRITE_EARNINGS = 'WRITE:EARNINGS',
  WRITE_ENTRIES = 'WRITE:ENTRIES',
}
